module.exports = __webpack_public_path__ + "static/media/600x300.0afdd6fa.png";